import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { AdminHeading, Card } from "@/components/admin/ui";

export default function ActivityLog() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/admin/activity", { params: { limit: 200 } }).then((r) => setRows(r.data)).catch((e) => toast.error(formatApiError(e))); }, []);
  return (
    <div data-testid="admin-activity">
      <AdminHeading title="Activity log" subtitle="Every change made by the admin team." />
      <Card className="divide-y divide-[rgba(20,40,26,.06)]">
        {(rows || []).map((a, i) => (
          <div key={a.id} className="px-5 py-3 flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4 text-sm" data-testid={`activity-row-${i}`}>
            <span className="text-xs text-[var(--ink-soft)] sm:w-40 shrink-0">{new Date(a.created_at).toLocaleString("en-IN")}</span>
            <span className="font-semibold sm:w-36 shrink-0">{a.admin_name}</span>
            <span className="font-mono text-xs px-2 py-0.5 rounded bg-[var(--paper-2)] w-fit">{a.action}</span>
            <span className="text-[var(--ink-soft)] truncate">{a.detail}</span>
          </div>
        ))}
        {rows && rows.length === 0 && <div className="p-8 text-center text-[var(--ink-soft)]">No activity yet.</div>}
      </Card>
    </div>
  );
}
